import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import {
  getArtisanStatsAction,
  getSupplierStatsAction,
  getSuperStatsAction,
  getAdminStatsAction,
  getCustomerStatsAction
} from '../../../modules/statistics/Actions';
import ArtisanStaticBar from './ArtisanStaticBar';
import SupplierStaticBar from './SupplierStaticBar';
import SuperStaticBar from './SuperStaticBar';
import AdminStaticBar from './AdminStaticBar';
import CustomerStaticBar from './CustomerStaticBar';
import ApplicantStatic from './ApplicantStatic';
import getLangData from '../../../utils/getLangData';
const StaticBar = ({
  currentUser,
  getArtisanStatsAction,
  getSupplierStatsAction,
  getSuperStatsAction,
  getAdminStatsAction,
  getCustomerStatsAction
}) => {
  const [activeScreen, setActiveScreen] = useState(null);
  useEffect(() => {
    // Super Admin
    if (currentUser?.defaultUserType === '0') {
      setActiveScreen(0);
      const id = currentUser?._id;
      if (id) getSuperStatsAction(id);
    }
    // Admin
    if (currentUser?.defaultUserType === '1') {
      setActiveScreen(1);
      const id = currentUser?._id;
      if (id) getAdminStatsAction(id);
    }

    // Artisan
    if (currentUser?.defaultUserType === '3') {
      setActiveScreen(3);
      const id = currentUser?.profiles?.artisan?._id;
      // if (id) getArtisanStatsAction(id);
    }
    // Customer
    if (currentUser?.defaultUserType === '4') {
      setActiveScreen(4);
      const id = currentUser?.profiles?.customer?._id;
      // if (id) getCustomerStatsAction(id);
    }
    // Supplier
    if (currentUser?.defaultUserType === '5') {
      setActiveScreen(5);
      const id = currentUser?.profiles?.supplier?._id;
      // if (id) getSupplierStatsAction(id);
    }
    if (currentUser?.defaultUserType === '6') {
      setActiveScreen(6);
      const id = currentUser?.profiles?.applicant?._id;
      // if (id) getSupplierStatsAction(id);
    }
  }, [currentUser?.defaultUserType]);

  // Render
  if (activeScreen === 0) return <SuperStaticBar />;
  if (activeScreen === 1) return <AdminStaticBar />;
  if (activeScreen === 3) return <ArtisanStaticBar />;
  if (activeScreen === 4) return <CustomerStaticBar />;
  if (activeScreen === 5) return <SupplierStaticBar />;
  if (activeScreen === 6) return <ApplicantStatic />;
  else return <div>{getLangData().general_words.loading}</div>;
};
const mapStateToProps = (state, props) => {
  return {
    artisanStats: state.stats.artisanStats,
    currentUser: state.users.currentUser
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    //   getArtisans: getArtisansAction,
    getArtisanStatsAction,
    getSupplierStatsAction,
    getSuperStatsAction,
    getAdminStatsAction,
    getCustomerStatsAction
  })(StaticBar)
);
